module.exports = __webpack_public_path__ + "img/link-04.78985b29.svg";